import React from 'react';
import Layout from '../components/Layout';
import MonitoringForm from '../components/MonitoringForm';
import { Settings } from 'lucide-react';

function WaitlistPage() {
  return (
    <Layout
      title="Tee Time Waitlist in Metro Vancouver | Snag Your Tee"
      description="Join the golf tee time waitlist in Metro Vancouver and get notified when spots open up. Snag Your Tee tracks cancellations and last-minute tee times across Vancouver, Burnaby, and Richmond."
    >

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 md:px-6 py-6 md:py-10">
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-8 border border-green-100">
          <div className="flex items-center space-x-2 md:space-x-3 mb-6 md:mb-8">
            <div className="p-2 md:p-3 bg-green-100 rounded-full">
              <Settings className="text-green-600" size={20} />
            </div>
            <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
              Join the Tee Time Waitlist in Metro Vancouver
            </h1>
          </div>
          <MonitoringForm />
        </div>

        {/* FAQ Section */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 border border-gray-100 mt-8">
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">
            Frequently Asked Questions
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="border border-gray-200 rounded-lg p-6">
              <h3 className="text-base font-semibold text-gray-800 mb-3">
                How does the golf tee time waitlist work?
              </h3>
              <p className="text-gray-600 leading-relaxed">
                When a course is sold out, you can join the waitlist by selecting your preferred date and time. We monitor cancellations and send you an alert as soon as an opening appears.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-6">
              <h3 className="text-base font-semibold text-gray-800 mb-3">
                Will the waitlist guarantee a tee time?
              </h3>
              <p className="text-gray-600 leading-relaxed">
                No, we can't guarantee availability. But joining the waitlist significantly improves your chances of grabbing last-minute tee times in Metro Vancouver.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-6">
              <h3 className="text-base font-semibold text-gray-800 mb-3">
                How will I be notified?
              </h3>
              <p className="text-gray-600 leading-relaxed">
                You'll receive an email alert with details of the newly available tee time. SMS notifications will be available soon for even faster alerts.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-6">
              <h3 className="text-base font-semibold text-gray-800 mb-3">
                Which Metro Vancouver golf courses support the waitlist?
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Currently, you can join the waitlist for Langara, Fraserview, McCleery, and UBC in Vancouver; Burnaby Mountain and Riverway in Burnaby; plus Country Meadows, Savage Creek, and Mylora in Richmond.
              </p>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default WaitlistPage;